import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  clearSuperadminViewStore,
  getSuperadminViewStore,
  type SuperadminViewStore,
} from '../../utils/superadminStoreView';

const SuperadminViewBanner: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [view, setView] = useState<SuperadminViewStore | null>(() => getSuperadminViewStore());

  useEffect(() => {
    setView(getSuperadminViewStore());
  }, [location.pathname]);

  if (!view) {
    return null;
  }

  const handleExit = () => {
    clearSuperadminViewStore();
    navigate('/admin', { replace: true });
  };

  return (
    <div className="bm-superadmin-view-banner" role="status">
      <span className="bm-superadmin-view-banner-text">
        Modo soporte: viendo <strong>{view.storeName}</strong> (ID {view.storeId})
      </span>
      <button type="button" className="bm-superadmin-view-banner-btn" onClick={handleExit}>
        Volver al admin
      </button>
    </div>
  );
};

export default SuperadminViewBanner;
